// PrivacyPolicy.js
import React from 'react';
import { Card, Typography, Divider, Row, Col, Button } from 'antd';
import { ArrowLeftOutlined, SafetyOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const PrivacyPolicy = () => {
  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: 'var(--body-bg)', 
      padding: '20px 0' 
    }}>
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        padding: '0 20px' 
      }}>
        {/* Header Section */}
        <Row justify="center" style={{ marginBottom: '30px' }}>
          <Col xs={24} lg={20}>
            <Card className="new-card" style={{ textAlign: 'center', marginBottom: '20px' }}>
              <SafetyOutlined 
                style={{ 
                  fontSize: '48px', 
                  color: '#1890ff', 
                  marginBottom: '16px' 
                }} 
              />
              <Title level={1} className="txt-color" style={{ margin: '0 0 16px 0' }}>
                Privacy Policy
              </Title>
              <Paragraph className="txt-color-secondary" style={{ fontSize: '16px', margin: 0 }}>
                HRM360 - Your privacy is our priority
              </Paragraph>
            </Card>
          </Col>
        </Row>

        {/* Main Content */}
        <Row justify="center">
          <Col xs={24} lg={20}>
            <Card className="new-card">
              <div style={{ marginBottom: '24px' }}>
                <Paragraph className="txt-color" style={{ fontSize: '16px', lineHeight: '1.6' }}>
                  Your privacy is important to us. It is HRM360's policy to respect your privacy regarding any information we may collect from you across our website
                  <Text strong className="txt-color-2"> hrm360.softomation.com</Text>, and other sites or applications we own and operate.
                </Paragraph>
              </div>

              <Divider className="new-hr" />

              <div style={{ marginBottom: '32px' }}>
                <Title level={2} className="txt-color-2" style={{ marginBottom: '16px' }}>
                  1. Information We Collect
                </Title>
                <Paragraph className="txt-color" style={{ fontSize: '15px', lineHeight: '1.6' }}>
                  We only collect information about you if we have a reason to do so — for example, to provide our services, to communicate with you, or to make our services better.
                </Paragraph>

                <Title level={3} className="txt-color-secondary" style={{ marginTop: '24px', marginBottom: '12px' }}>
                  1.1 Location Data
                </Title>
                <Paragraph className="txt-color" style={{ fontSize: '15px', lineHeight: '1.6' }}>
                  HRM360 captures your location <Text strong className="txt-color-2">only while the app is in use</Text> to accurately mark attendance.
                  Location data is not shared with third parties and is used solely for attendance purposes.
                </Paragraph>

                <Title level={3} className="txt-color-secondary" style={{ marginTop: '24px', marginBottom: '12px' }}>
                  1.2 Device Information
                </Title>
                <Paragraph className="txt-color" style={{ fontSize: '15px', lineHeight: '1.6' }}>
                  To provide a better experience, we require certain device information (for example, to ensure correct app functionality and security).
                  This information is used strictly for operational purposes.
                </Paragraph>
              </div>

              <Divider className="new-hr" />

              <div style={{ marginBottom: '32px' }}>
                <Title level={2} className="txt-color-2" style={{ marginBottom: '16px' }}>
                  2. How We Use Information
                </Title>
                <Paragraph className="txt-color" style={{ fontSize: '15px', lineHeight: '1.6' }}>
                  We use the information we collect to:
                </Paragraph>
                <ul style={{ paddingLeft: '20px' }}>
                  <li><Text className="txt-color" style={{ fontSize: '15px' }}>Provide and improve our services</Text></li>
                  <li><Text className="txt-color" style={{ fontSize: '15px' }}>Monitor and analyze trends to understand how users interact with our services</Text></li>
                  <li><Text className="txt-color" style={{ fontSize: '15px' }}>Protect the security and integrity of our systems and network</Text></li>
                </ul>
              </div>

              <Divider className="new-hr" />

              <div style={{ marginBottom: '32px' }}>
                <Title level={2} className="txt-color-2" style={{ marginBottom: '16px' }}>
                  3. Information Sharing
                </Title>
                <Paragraph className="txt-color" style={{ fontSize: '15px', lineHeight: '1.6' }}>
                  We do not share personally identifying information publicly or with third parties, except when required by law.
                </Paragraph>
              </div>

              <Divider className="new-hr" />

              <div style={{ marginBottom: '32px' }}>
                <Title level={2} className="txt-color-2" style={{ marginBottom: '16px' }}>
                  4. Company-Managed Accounts
                </Title>
                <Card 
                  style={{ 
                    backgroundColor: 'var(--bg-item-selected)', 
                    border: '1px solid var(--text-color-2)',
                    marginBottom: '16px'
                  }}
                >
                  <Paragraph className="txt-color" style={{ fontSize: '15px', lineHeight: '1.6', margin: 0 }}>
                    This application is intended <Text strong className="txt-color-2">solely for enterprise use</Text>.
                    All user accounts are <Text strong className="txt-color-2">created and managed by the company's HR or administrative team</Text>.
                    As the data forms part of the company's official HR records,
                    <Text strong className="txt-color-2"> individual employees cannot permanently delete their accounts or associated data</Text>.
                    For any data-related concerns, employees should contact their company's HR department.
                  </Paragraph>
                </Card>
              </div>

              <Divider className="new-hr" />

              <div style={{ marginBottom: '32px' }}>
                <Title level={2} className="txt-color-2" style={{ marginBottom: '16px' }}>
                  5. Your Privacy Rights
                </Title>
                <Paragraph className="txt-color" style={{ fontSize: '15px', lineHeight: '1.6' }}>
                  Employees may request access to the personal data collected about them or request corrections by contacting their HR or administrative team.
                </Paragraph>
              </div>

              <Divider className="new-hr" />

              <div style={{ marginBottom: '32px' }}>
                <Title level={2} className="txt-color-2" style={{ marginBottom: '16px' }}>
                  6. Changes to This Privacy Policy
                </Title>
                <Paragraph className="txt-color" style={{ fontSize: '15px', lineHeight: '1.6' }}>
                  We may revise this Privacy Policy from time to time. We encourage visitors and customers to review this page periodically for updates.
                </Paragraph>
              </div>

              <Divider className="new-hr" />

              <div style={{ 
                textAlign: 'center', 
                padding: '24px', 
                backgroundColor: 'var(--bg-column)', 
                borderRadius: '8px' 
              }}>
                <Paragraph className="txt-color" style={{ fontSize: '15px', lineHeight: '1.6', margin: 0 }}>
                  If you have any questions about this Privacy Policy, please contact us.
                </Paragraph>
              </div>

              {/* Back to Login Button */}
              <div style={{ textAlign: 'center', marginTop: '32px' }}>
                <Link to="/admin/auth/login">
                  <Button 
                    type="primary" 
                    icon={<ArrowLeftOutlined />} 
                    size="large"
                    style={{ 
                      borderRadius: '6px',
                      height: '40px',
                      paddingLeft: '24px',
                      paddingRight: '24px'
                    }}
                  >
                    Back to Login
                  </Button>
                </Link>
              </div>
            </Card>
          </Col>
        </Row>

        {/* Footer */}
        <Row justify="center" style={{ marginTop: '30px' }}>
          <Col xs={24} lg={20}>
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <Text className="txt-color-secondary" style={{ fontSize: '14px' }}>
                © {new Date().getFullYear()} HRM360 by{' '}
                <a 
                  href="https://softomation.com" 
                  target="_blank" 
                  rel="noreferrer"
                  style={{ color: 'var(--text-color-2)' }}
                >
                  Softomation Technologies
                </a>
              </Text>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
